/* global axios */
import ApiClient from './ApiClient';

class ScheduledNotificationsAPI extends ApiClient {
  constructor() {
    super('scheduled_notifications', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { scheduled_notification: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { scheduled_notification: data });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  resend(id) {
    return axios.post(`${this.url}/${id}/resend`);
  }

  getDeliveries(id, params = {}) {
    return axios.get(`${this.url}/${id}/deliveries`, { params });
  }
}

export default new ScheduledNotificationsAPI();
